export const AWS_REGION = process.env.REACT_APP_AWS_REGION;
export const GEONIUS_DATA_STORE = process.env.REACT_APP_GEONIUS_DATA_STORE;
const AWS_USER_POOL_ID = process.env.REACT_APP_AWS_USER_POOL_ID;
const AWS_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID;
const AWS_USER_POOL_WEBCLIENT_ID =
  process.env.REACT_APP_AWS_USER_POOL_WEBCLIENT_ID;
const GEONIUS_BACKEND_URL_ROOT = process.env.REACT_APP_GEONIUS_BACKEND_URL;
const ENTITY_DOCUMENTS_BUCKET =
  process.env.REACT_APP_ENTITY_DOCUMENTS_BUCKET_NAME;
const ATLAS_ENDPOINT_URL_ROOT = process.env.REACT_APP_ATLAS_ENDPOINT_URL_ROOT;
const GEOSPATIAL_ENDPOINT_URL_ROOT =
  process.env.REACT_APP_GEOSPATIAL_ENDPOINT_URL_ROOT;

/**
 * AWS Amplify Configuration (v6)
 * * API NOTE:
 * REST endpoints are now organized as a keyed object under 'REST' rather than
 * an array of 'endpoints'.
 */
const awsExports = {
  Auth: {
    region: AWS_REGION as string,
    Cognito: {
      userPoolId: AWS_USER_POOL_ID as string,
      userPoolClientId: AWS_USER_POOL_WEBCLIENT_ID as string,
      identityPoolId: AWS_IDENTITY_POOL_ID as string,
    },
  },
  Storage: {
    S3: {
      bucket: ENTITY_DOCUMENTS_BUCKET as string,
      region: AWS_REGION as string,
    },
  },
  API: {
    REST: {
      geonius: {
        endpoint: GEONIUS_BACKEND_URL_ROOT as string,
        region: AWS_REGION as string,
      },
      mapbox: {
        endpoint: 'https://api.mapbox.com',
      },
      atlas: {
        endpoint: ATLAS_ENDPOINT_URL_ROOT as string,
      },
      geospatial: {
        endpoint: GEOSPATIAL_ENDPOINT_URL_ROOT as string,
        region: AWS_REGION as string,
      },
    },
  },
};

export default awsExports;
